/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

const isNumber = (value: number | string | void): boolean => typeof value === 'number' && isFinite(value as number);

const makeTwoDigit = (number: number): string => (number < 10 ? `0${number}` : `${number}`);

const makePercentFromNumber = (value: number | undefined): string | undefined => value ? `${value}%` : undefined;

const valueInRange = (value: number, ...ranges: [number, number?][]): boolean =>
    ranges.some(range => range[0] && (isNumber(range[1]) ? (value >= range[0] && value <= (range[1] as number)) : true));

export {
    isNumber,
    makeTwoDigit,
    makePercentFromNumber,
    valueInRange,
};
